"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createExportTask = createExportTask;
exports.getExportTaskStatus = getExportTaskStatus;
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 创建导出任务
 * @param {Object} data 导出任务参数
 */
function createExportTask(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/export/task',
    method: 'post',
    data: data
  });
}

/**
 * 查询导出任务状态
 * @param {number|string} taskId 导出任务ID
 */
function getExportTaskStatus(taskId) {
  return (0, _requestMapi.default)({
    url: "/mapi/system/admin/download/async/task/".concat(taskId),
    method: 'get'
  });
}